module.exports = __webpack_public_path__ + "static/media/VICTORY7.651c4a6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/VICTORY7.mp3
// module id = 307
// module chunks = 1 2 3